import { Grid } from "@material-ui/core";
import React from "react";

export class InputDecimal extends React.Component {
  constructor(prop) {
    super(prop);
    this.state = { input: "" };
    this.start = 0;
  }

  container = {
    dsiplay: 'flex',
    alingItems: 'center'
  }


  render() {
    return (
      <Grid
        item
        xs={12}
        lg={12}
        md={12}
        sm={12}
        className="inputHLPure-container"
      >  
        <div className="" style={this.container} >
          <label className="inputHLPure-label" name="label">
            {this.props.labelInput || ""}
          </label>
          <input
            type="text"
            onBlur={this.props.onBlur}
            onChange={this.props.onChange}
            value={this.props.valueInput}
            {...this.props}
          />
        </div>
      </Grid>
    );
  }
}
